import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBranchBalanceApi } from "../../../apiservice/reports";

export const fetchBranchBalance = createAsyncThunk(
  "branchBalance/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
   
      const payload = {
        branchId: filters?.branchId || null,
      };
      const res = await getBranchBalanceApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
